export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13121.d2725c86.jpg";